<template>
  <div>
    <mz-disconnect v-if="device.connected" :device="device"></mz-disconnect>
    <mz-connect v-else :device="device" :disabled="demoSettings.enabled"></mz-connect>
  </div>  
</template>

<script>
import Connect from '@/components/controls/Connect'
import Disconnect from '@/components/controls/Disconnect'

import { mapGetters, mapMutations } from 'vuex'

const log = window.debug('mz-controls')

export default {
  name: 'controls',
  data () {
    return {
      device: null
    }
  },
  computed: {
    ...mapGetters(['connected', 'sensors', 'demoSettings'])
  },
  methods: {
    ...mapMutations({
      setConnected: 'setConnected',
      pushSensorData: 'pushSensorData',
      setDevice: 'setDevice',
      alert: 'pushAlert'
    })
  },
  created () {
    this.device = window.mzBleDevice
    this.setDevice(this.device)

    this.device.on('connected', () => {
      this.setConnected(true)
    })

    this.device.on('disconnected', () => {
      this.setConnected(false)
      this.alert({ msg: 'Disconnected!', context: 'info' })
    })

    this.device.on('data', (msg) => {
      log(msg)

      this.pushSensorData(msg)
    })

    // setInterval(() => {
    //   const msg = {
    //     id: 'acx',
    //     timestamp: Date.now(),
    //     value: 5
    //   }
    //   log(msg)

    //   this.pushSensorData(msg)
    // }, 1000)
  },
  components: {
    mzConnect: Connect,
    mzDisconnect: Disconnect
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/controls/Controls.vue